import React from 'react';
import ButtonLink from '../components/Button';

const Partners = () => {
  return (
    <div className="page companies-page">
      <section className="page-header">
        <div className="container">
          <h1>Partners</h1>
          <p>Information for partners</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="info-card mb-2">
            <h3>Information for partners</h3>
            <p>
              If you are interested in partnering with Integralis, we would love to work with
              you.
            </p>
            <p>
              Founded in 2019, Integralis ry is the student organisation for all international students at Kumpula campus of University of Helsinki 
              and the main student organisation for the Bachelor's Programme in Science. Our members study computer science
              mathematics, physics, chemistry and many other disciplines in English, and our events
              attract many international science students. We currently have around 200 members and
              up to 70 new students join Integralis every year.
            </p>
            <p>
              Read more below:
            </p>
            <p className="documents-item">
                <ButtonLink href="partners/partnership_options" newTab="False">
                  Partnership options (online)
                </ButtonLink>
              </p>
            <p className="documents-item">
                <ButtonLink href="https://cdn.jsdelivr.net/gh/integralis-ry/site_binaries//documents/Partnership%20Options%202026.pdf">
                  Partnership options (pdf)
                </ButtonLink>
              </p>
              
          </div>

          <div className="info-card mb-2">
            <h3>Forms of cooperation</h3>
            <ul>
              <li>
                <strong>Overall advertisements</strong> – partnership logos on student overalls are a
                simple and long-lasting way to be visible in student life, as overalls are worn
                throughout the academic year.
              </li>
              <li>
                <strong>Talent recruitment</strong> – reach our students through our mailing list
                and dedicated jobs channel on Telegram by advertising internships, thesis positions
                and full-time roles.
              </li>
              <li>
                <strong>On-premise excursions</strong> – invite Integralis members to visit your
                premises, present what you do, and showcase career opportunities.
              </li>
              <li>
                <strong>Anniversary party</strong> – our annual academic table party in November is
                attended by students, alumni and staff. Opportunities include giving a speech or
                having your logo on the dinner card.
              </li>
              <li>
                <strong>Other ideas</strong> – we are always happy to discuss new forms of
                cooperation that fit both your goals and our community.
              </li>
            </ul>
          </div>

          <div className="info-card">
            <h3>Contact for cooperation</h3>
            <p>
              For cooperation enquiries, please contact our Career Officer:
            </p>
            <ul>
              <li>Daniel Mlesnita – daniel.mlesnita@helsinki.fi</li>
              <li>Integralis phone number: +358 44 961 0885</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partners;


